import api from "../../../../../../api/axios"
import { BankAccount } from "../../../../../../legacyComponents/util/api/apis/customer"

export default async function submitBillingAccount(values, user, employer, account) {
	try {
		console.log("In submitBillingAccount, values = ", values)
		let bank = values?.bank
		const existingId = values.bankAccountId || account?.id
		if (existingId) bank = await updateAccount(values, employer, { ...account, id: existingId })
		else bank = await createAccount(values, user, employer)
		await setBillingAccount(bank, employer)
	} catch (error) {
		console.error(error)
	}
}

async function createAccount(values, user, employer) {
	try {
		const { bank, bankName, nickname, accountType, accountNumber, code } = values

		const payload = {
			...bank,
			bankName,
			nickname,
			accountType,
			accountNumber,
			code
		}

		const params = { employerId: employer?.id, nickname }

		const { data: employerBankData } = await api.post(`employer/${params.employerId}/bankAccount`, payload)

		return new BankAccount(employerBankData)

	} catch (error) {
		console.error(error)
	}
}

async function updateAccount(values, employer, account) {
	try {
		const { bank, bankName, nickname, accountType, accountNumber, code } = values

		const payload = {
			...bank,
			bankName,
			nickname,
			accountType,
			accountNumber,
			code
		}

		const url = `employer/${employer?.id}/bankAccount/${account?.id}`
		const response = await api.patch(url, payload)

		return response?.data
	} catch (error) {
		console.error(error)
	}
}

async function setBillingAccount(bank, employer) {
	try {
		const payload = {
			id: bank?.id,
			useForBilling: true,
			accountType: "BANK_ACCOUNT"
		}
		await api.post(`employer/${employer.id}/account`, payload)
	} catch (error) {
		console.error(error)
	}
}
